// Vendor imports
const Bluebird = require('bluebird')
const _ = require('lodash')
// Client V1 imports
const { send: ajax } = require('client/lib/request')
// Sibling imports
const sharedConversationActions = require('../shared-conversation/actions')

// Action types
const SHARED_INBOX_POSTS_LOADED = 'NOTIFICATIONS_SHARED_INBOX_POSTS_LOADED'
const SHARED_INBOX_SET_SEARCH_TEXT = 'NOTIFICATIONS_SHARED_INBOX_SET_SEARCH_TEXT'
const SHARED_INBOX_THREADS_FAILED = 'NOTIFICATIONS_SHARED_INBOX_THREADS_FAILED'
const SHARED_INBOX_THREADS_LOADED = 'NOTIFICATIONS_SHARED_INBOX_THREADS_LOADED'
const SHARED_INBOX_THREADS_LOADING = 'NOTIFICATIONS_SHARED_INBOX_THREADS_LOADING'

// Action creators

function setSearchText(searchText) {
  return {
    type: SHARED_INBOX_SET_SEARCH_TEXT,
    payload: { searchText }
  }
}

// Action dispatchers

function loadThreads() {
  return async function (dispatch, getState) {
    const { user } = getState()
    dispatch({
      type: SHARED_INBOX_THREADS_LOADING
    })
    try {
      const items = await ajax({
        url: `/api/v0.1/shares`,
        method: 'get'
      })
      dispatch({
        type: SHARED_INBOX_THREADS_LOADED,
        payload: { items }
      })
      if (items.length) {
        const [ firstThread ] = _.orderBy(items, 'created_at', 'desc')
        dispatch(sharedConversationActions.loadConversation(firstThread.user))
      } else {
        dispatch({
          type: SHARED_INBOX_POSTS_LOADED,
          payload: await Bluebird.props({
            hasFriends: hasShareableFriends(user.id),
            recentPosts: fetchRecentPosts(user.id)
          })
        })
      }
    } catch (err) {
      dispatch({
        type: SHARED_INBOX_THREADS_FAILED
      })
      throw err
    }
  }
}

module.exports = {
  // Action types
  SHARED_INBOX_POSTS_LOADED,
  SHARED_INBOX_SET_SEARCH_TEXT,
  SHARED_INBOX_THREADS_FAILED,
  SHARED_INBOX_THREADS_LOADED,
  SHARED_INBOX_THREADS_LOADING,
  // Action creators
  setSearchText,
  // Action dispatchers
  loadThreads
}

// Helpers

async function hasShareableFriends(userId) {
  const { friends } = await ajax({
    url: `/api/v0.1/user/${userId}/shareable-friends/1`,
    method: 'post'
  })
  return friends.length > 0
}

async function fetchRecentPosts(userId) {
  const { items } = await ajax({
    url: `/api/v0.1/user/${userId}/posts/1`,
    method: 'get'
  })
  return items.slice(0, 3)
}
